export const DELIVERY_SETTINGS_STORAGE_KEY = 'vs-admin:delivery-settings';

export const DEFAULT_BUFFER_DAYS = 7;

// No backend option-type constant exists for "Timber Look Joints" yet — its
// numeric value comes from ALL_OPTION_TYPES in
// @/features/product-configurator/constants/optionTypes.
export const OPTION_TYPE_TIMBER_LOOK_JOINTS = 94;

// Internal/external foil profile colour questions — these are
// FOIL_COLOUR_OPTION_TYPES in @/features/assistant/constants, only shown/
// priced when the PROFILE_COLOR_OPTION (60) answer contains "foil".
export const OPTION_TYPE_INTERNAL_PROFILE_COLOUR = 35;
export const OPTION_TYPE_EXTERNAL_PROFILE_COLOUR = 34;

export const queryKey = {
  getCalendars: 'getCalendars',
  getHolidays: 'getHolidays',
  getDeliverySettings: 'getDeliverySettings',
  getBufferDaysRules: 'getBufferDaysRules',
};
